import { render, staticRenderFns } from "./mouth_video_library.vue?vue&type=template&id=47cafed6"
import script from "./mouth_video_library.vue?vue&type=script&lang=js"
export * from "./mouth_video_library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports